import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { confirmDialog } from "primereact/confirmdialog";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";

// ------------------ COMPONENTES DE BASE--------------------------
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";
import Card from "../../../../../Base/Components/Card/Card";
import { useForm } from "../../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { getDateTimeStringSQL } from "../../../../../Base/Services/Moment/Luxon";

// ------------------- CONSULTAS A LA API---------------------------
import { getTipoMantenimiento, getTipoParo, getTipoTrabajo } from "../../../../../API/Mantenimiento/MantenimientoRequest";
import { EliminarTarea, GuardarOrdenesTrabajo, ObtenerDetalleOrdenesT, ObtenerEncabezadoOrdenesT, ObtenerSiguienteNoOrdenT } from "../../../../../API/Mantenimiento/OrdenesTrabajo/OrdenesTrabajoRequest";
import { getAreasAct } from "../../../../../Base/API/Global/Areas/AreasRequests";
import { obtenerPrioridades } from "../../../../../Base/API/Global/Prioridades/PrioridadesRequests";
import { getLiberarRequisas } from "../../../../../Base/API/IT/Accesos/AccesosRequests";
import { getTypesCategoria } from "../../../../../Base/API/Global/Types/TypeRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import EncabezadoOrdenesTrabajo from "./EncabezadoOrdenesTrabajo";
import ActivosFijosOverlayPanel from "./Overlay/OverlayActivoFijo";
import SubTareasCRUD from "./SubTareasCRUD";
import CrudRequisa from "../../../Compras/Requisas/CrudRequisa/CrudRequisa";
import RequisaMaterialCrud from "../../../Suministros/Bodegas/RequisasMateriales/RequisasMaterialesCRUD/RequisaMaterialCrud";
import RequisasDeAsignaciones from "./RequisasDeAsignaciones";



const OrdenesTrabajoCRUD = ({
  idOrden,
  setOrdenToShow = () => {},
  actualizarIngresosScreen = () => {},
  setOrdenDialog = () => {},
  setOrderToShow = () => {},
  listadoDet,
  habilitar,
  setHabilitar,
}) => {

  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const [detalles, setDetalles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userSolicita, setUserSolicita] = useState([]);
  const [selected, setSelected] = useState([]);
  const [selectedParaR, setSelectedParaR] = useState(null);
  const [tipoMantenimiento, setTipoMantenimiento] = useState([]);
  const [tipoTrabajo, setTipoTrabajo] = useState([]);
  const [tipoParo, setTipoParo] = useState([]);
  const [areas, setAreas] = useState([]);
  const [prioridad, setPrioridades] = useState([]);
  const [modalAsignaciones, setModalAsignaciones] = useState(false);
  const [types, setTypes] = useState([]);
  const [sinActivo, setSinActivo] = useState(false);
  const [asignaciones, setAsignaciones] = useState([]);
  const [abrirRequisaCompras, setAbrirRequisaCompras] = useState(false);
  const [habilitarReqCompras, setHabilitarReqCompras] = useState(true);
  const [abrirRequisaMaterial, setAbrirRequisaMaterial] = useState(false);
  const [habilitarReqMaterial, setHabilitarReqMaterial] = useState(true);
  const [showRequisas, setShowRequisas] = useState(false);

  //  PARA ENCABEZADO EL VALUES
  const initialValues = {
    FechaCreado: new Date(),
    IdEstado: 47,
    StatusName: "Solicitado",
    IdOrdenDeTrabajo: -1,
    NoOrdenTrabajo: idOrden ? idOrden : "",
  };

  const { values, setValues, handleInputChange, handleChange, resetForm } = useForm(initialValues);

  // OBTENER INFORMACION PARA LOS DROPDAWN
  const getInfo = async () => {
    setLoading(true);

    const userTempo = await getLiberarRequisas();
    setUserSolicita(userTempo);

    const tMantenimientoTempo = await getTipoMantenimiento();
    setTipoMantenimiento(tMantenimientoTempo);

    const tTrabajoTempo = await getTipoTrabajo();
    setTipoTrabajo(tTrabajoTempo);

    const tParoTempo = await getTipoParo();
    setTipoParo(tParoTempo);

    const areasTempo = await getAreasAct();
    setAreas(areasTempo);

    const typesTempo = await getTypesCategoria('ActivoFijo');

    const newType = {
      AbbreviatedType: null,
      Descripcion: null,
      FechaCreate: null,
      IdType: 0,
      IdUserCreate: null,
      Type: "Sin Activo",
      TypeCategory: null
    };
  
    const updatedTypes = [...typesTempo, newType];
    setTypes(updatedTypes);

    const prioridadesTempo = await obtenerPrioridades();
    setPrioridades(prioridadesTempo);

    setLoading(false);
  };

  // OBTENER VALORES INICIALES PARA CREAR UNA NUEVA ORDEN DE TRABAJO
  const getInfoNew = async () => {
    setLoading(true);
    const NordenT = await ObtenerSiguienteNoOrdenT();
    // setOrdenT(NordenT);

    const d = {
      ...values,
      IdOrdenDeTrabajo: -100,
      NoOrdenTrabajo: NordenT[0].NumeroOrden,
    };
    setTimeout(() => {
      setValues(d);
    }, 300);
    setLoading(false);
  };

  // OBTENER PARA EDITAR UNA ORDEN DE TRABAJO
  const obtenerOrdenT = async (orden) => {
    setLoading(true);

    let req = orden ? orden : values;
    const det = await ObtenerDetalleOrdenesT(req.NoOrdenTrabajo);
    setDetalles(det);


    const enc = await ObtenerEncabezadoOrdenesT(req.NoOrdenTrabajo);
    // setEncabezado(t);
    if (enc.length > 0) {
      const [detailOrdenes] = enc;
      const n = {
        ...detailOrdenes,
        FechaCreado: new Date(detailOrdenes.FechaCreado),
      };
      setValues(n);
      if(n?.IdTipo === 0 || n?.IdTipo === null){
        setSinActivo(true)
        setValues({
          ...n,
          IdType: 0,
          Type: 'Sin Activo'
        })
      }
      setOrdenToShow(detailOrdenes.NoOrdenTrabajo);
      setHabilitar(false);
    } else {
      const d = {
        ...initialValues,
        NoOrdenTrabajo: values.NoOrdenTrabajo,
        Comentario: "",
      };
      setValues(d);
      setDetalles([]);
      toastShow( toast, "warn", "Error al obtener", "No se encontro la orden de trabajo." );
      setHabilitar(true);
    }
    setLoading(false);
  };

  // AGREGAR NUEVA FILA
  const agregarNuevaFila = () => {
    let newRowData = [...detalles];

    if(values?.Type?.IdType === 0){
      setSinActivo(true)
    }

    let IdDet = -(detalles?.length +  1)
    const newData = {
      IdOrdenDeTrabajoDet: IdDet,
      FechaCreado: new Date(),
      IdEstado: 47,
      StatusName: "Solicitado",
      NoOrdenTrabajo: values.NoOrdenTrabajo,
      EnParo: false,
      IdActivo: "",
      IdTipoMantenimiento: "",
      IdTipoTrabajo: "",
      IdTipoParo: "",
      IdArea: "",
      IdPriority: "",
    };
    if (newRowData.length > 0) {
      if (newRowData[newRowData.length - 1].IdOrdenDeTrabajoDet) {
        newRowData.push(newData);
      } else {
        newRowData[newRowData.length - 1] = newData;
      }
    } else {
      newRowData.push(newData);
    }
    setDetalles(newRowData);
  };

  // AGREGAR ACTIVO FIJO
  const changeActivoF = ({ data }) => {
    return (
      <ActivosFijosOverlayPanel
        rowData={data}
        onChange={({ api, data }, rowData) => {
          const index = detalles.findIndex(
            (detail) =>
              detail.IdOrdenDeTrabajoDet === rowData.IdOrdenDeTrabajoDet
          );
          let newDetail = [...detalles];
          newDetail[index].IdActivo = data.IdActivo;
          newDetail[index].CodigoActivo = data.CodigoActivo;
          newDetail[index].NombreActivo = data.NombreActivo;
          newDetail[index].IdArea = data.IdArea;
          newDetail[index].Area = data.Area;
          setDetalles(newDetail);
          api.stopEditing();
        }}
      />
    );
  };

  const handleCheckboxChange = (rowData, checked) => {
    const index = detalles.findIndex(
        (detail) =>
          detail.IdOrdenDeTrabajoDet === rowData.IdOrdenDeTrabajoDet
      );
    const updatedDetalles = [...detalles];
    updatedDetalles[index].EnParo = checked;
    setDetalles(updatedDetalles);
  };  

  // GUARDAR O EDITAR ORDENES DE TRABAJO
  const guardarOrdenesTrabajo = async () => {
    let guardar = true;
    if (detalles.length === 0) {
      toastShow( toast, "error", "Error al guardar", "Debe agregar al menos una tarea." );
      guardar = false;
    } else {
      detalles.forEach((d) => {
        if(!sinActivo){
          if (d.IdActivo === "") {
            toastShow( toast, "warn", "Advertencia", "Todos las tareas deben tener un Activo Fijo." );
            guardar = false;
            return
          }
        }
        if (d.IdTipoMantenimiento === "") {
          toastShow( toast, "warn", "Advertencia", "Todos las tareas deben tener un Tipo de Mantenimiento." );
          guardar = false;
          return
        }
        if (d.IdTipoTrabajo === "") {
          toastShow( toast, "warn", "Advertencia", "Todos las tareas deben tener un Tipo de Trabajo." );
          guardar = false;
          return
        }
        if (!d.Descripcion) {
          toastShow( toast, "warn", "Advertencia", "Todos las tareas deben contener una Descripción." );
          guardar = false;
          return
        }
        if (d.IdPriority === "") {
          toastShow( toast, "warn", "Advertencia", "Todos las tareas deben tener una Prioridad." );
          guardar = false;
          return
        }
      });
    }

    setLoading(false)
    if (guardar) {
      setLoading(true);
      setHabilitar(true);

      const encabezado = {
        IdOrdenDeTrabajo: values.IdOrdenDeTrabajo,
        NoOrdenTrabajo: values.NoOrdenTrabajo,
        FechaCreado: getDateTimeStringSQL(new Date(values.FechaCreado)),
        IdUsuarioCreo: userAuth.IdUser,
        IdUsuarioSolicita: values.UserName?.IdUser || values.IdUsuarioSolicita,
        Comentario: values.Comentario,
        IdEstado: values.IdEstado,
        IdArea: values?.Area?.IdArea || values?.IdArea,
        IdTipo: values?.Type?.IdType || values?.IdTipo,
      };

      const detallesOrden = detalles.map((detalle) => ({
        ...detalle,
        IdOrdenDeTrabajoDet: detalle.IdOrdenDeTrabajoDet,
        IdOrdenDeTrabajoEnc: values.IdOrdenDeTrabajo,
        FechaCreado: getDateTimeStringSQL(new Date(values.FechaCreado)),
        IdActivoFijo: detalle.IdActivo || detalle.IdActivoFijo,
        IdArea: detalle.IdArea,
        IdPrioridad: detalle.IdPriority || detalle.IdPrioridad,
        IdEstado: detalle.IdEstado,
        Descripcion: detalle.Descripcion,
        IdTipoMantenimiento: detalle.IdTipoMantenimiento,
        IdTipoTrabajo: detalle.IdTipoTrabajo,
        IdTipoParo: detalle.IdTipoParo,
        EnParo: detalle.EnParo,
        Asignaciones: [...(detalle.Asignaciones || [])]
      }));

      setLoading(false);

      const respuestaDetalles = await GuardarOrdenesTrabajo(encabezado, detallesOrden);

      if (respuestaDetalles[0].ESTADO !== -1) {
        setHabilitar(false);
        toastShow( toast, "success", "Guardado", respuestaDetalles[0].MENSAJE
        );
        obtenerOrdenT()
        actualizarIngresosScreen();
        setLoading(false);
      } else {
        toastShow( toast, "error", "Error", respuestaDetalles[0].MENSAJE );
        setLoading(false);
      }

    } else {
      setLoading(false);
    }
  };

  // ELIMINAR ITEM
  const eliminarItemDetalle = () => {
    if (selected.length > 0) {
      confirmDialog({
        message: "Esta seguro que desea eliminar este item",
        header: "Cancelar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Si",
        accept: () => cancelarDetalle(2),
        rejectLabel: "No",
        style: { backgroundColor: "white" },
      });
    } else {
      toastShow( toast, "warn", "Advertencia", "Debe seleccionar un detalle" );
    }
  };

  // ELIMINAR ITEM
  const cancelarDetalle = () => {
    const detallesOrden = selected.map((detalle) => ({
      ...detalle,
      IdUserDelete: userAuth.IdUser
    }));
    detallesOrden.forEach(async (select) => {
      if (select.IdOrdenDeTrabajoDet > 0) {
        if (select?.IdEstado !== 54) {
          const result = await EliminarTarea(select);
          if (result[0]?.ESTADO === 1) {
            let tempo = [...detalles];
            detallesOrden.forEach((select) => {
              select.IdEstado = 54;
              select.StatusName = "Eliminado";
              let f = tempo.findIndex( (t) => t.IdOrdenDeTrabajoDet === select.IdOrdenDeTrabajoDet );
              tempo[f] = select;
            });
            toastShow( toast, "success", "Eliminado", "Detalle de orden de trabajo eliminado Correctamente." );
            setDetalles(tempo);
            actualizarIngresosScreen();
          }
        } else {
          toastShow( toast, "error", "Error", "El Detalle de orden de trabajo seleccionado ya está cancelado." );
        }
      } else {
        let tempo2 = detalles.filter( (i) => !selected.some((e) => e.IdOrdenDeTrabajoDet === i.IdOrdenDeTrabajoDet) );
        setDetalles(tempo2);
      }
    }
  );
    setSelected([]);
  };

  const changeTipoMantenimiento = ({ data, oldValue, api }, column) => {
    return (
      <div>
        <Dropdown
          value={
            tipoMantenimiento.filter(
              (e) => e.IdTipoMantenimiento === data.IdTipoMantenimiento
            )[0]
          }
          style={{ width: '100%' }}
          options={tipoMantenimiento}
          optionLabel="TipoMantenimiento"
          filter
          filterBy="TipoMantenimiento"
          onChange={(e) => {
            let tempo2 = [...detalles];
            const index = detalles.findIndex(
              (detail) =>
                detail.IdOrdenDeTrabajoDet === data.IdOrdenDeTrabajoDet
            );
            tempo2[index].IdTipoMantenimiento = e.value.IdTipoMantenimiento;
            tempo2[index].TipoMantenimiento = e.value.TipoMantenimiento;
            setDetalles(tempo2);
          }}
        />
      </div>
    );
  };

  const changeTipoTrabajo = ({ data, oldValue, api }, column) => {
    return (
      <div>
        <Dropdown
          value={
            tipoTrabajo.filter((e) => e.IdTipoTrabajo === data.IdTipoTrabajo)[0]
          }
          options={tipoTrabajo}
          optionLabel="TipoTrabajo"
          filter
          style={{ width: '100%' }}
          filterBy="TipoTrabajo"
          onChange={(e) => {
            let tempo2 = [...detalles];
            const index = detalles.findIndex(
              (detail) =>
                detail.IdOrdenDeTrabajoDet === data.IdOrdenDeTrabajoDet
            );
            tempo2[index].IdTipoTrabajo = e.value.IdTipoTrabajo;
            tempo2[index].TipoTrabajo = e.value.TipoTrabajo;
            setDetalles(tempo2);
          }}
          //   disabled={!editable}
        />
      </div>
    );
  };

  const changeTipoParo = ({ data, oldValue, api }, column) => {
    return (
      <div>
        <Dropdown
          value={tipoParo.filter((e) => e.IdTipoParo === data.IdTipoParo)[0]}
          options={tipoParo}
          optionLabel="TipoParo"
          filter
          filterBy="TipoParo"
          onChange={(e) => {
            let tempo2 = [...detalles];
            const index = detalles.findIndex(
              (detail) =>
                detail.IdOrdenDeTrabajoDet === data.IdOrdenDeTrabajoDet
            );
            tempo2[index].IdTipoParo = e.value.IdTipoParo;
            tempo2[index].TipoParo = e.value.TipoParo;
            setDetalles(tempo2);
          }}
          //   disabled={!editable}
        />
      </div>
    );
  };

  const changeArea = ({ data, oldValue, api }, column) => {
    return (
      <div>
        <Dropdown
          value={areas.filter((e) => e.IdArea === data.IdArea)[0]}
          options={areas}
          optionLabel="Area"
          filter
          filterBy="Area"
          style={{ width: '100%' }}
          onChange={(e) => {
            let tempo2 = [...detalles];
            const index = detalles.findIndex(
              (detail) =>
                detail.IdOrdenDeTrabajoDet === data.IdOrdenDeTrabajoDet
            );
            tempo2[index].IdArea = e.value.IdArea;
            tempo2[index].Area = e.value.Area;
            setDetalles(tempo2);
          }}
        />
      </div>
    );
  };

  const changePrioridad = ({ data, oldValue, api }, column) => {
    return (
      <div>
        <Dropdown
          value={prioridad.filter((e) => e.IdPriority === data.IdPriority)[0]}
          options={prioridad}
          optionLabel="Priority"
          filter
          style={{ width: '125px' }}
          filterBy="Priority"
          onChange={(e) => {
            let tempo2 = [...detalles];
            const index = detalles.findIndex(
              (detail) =>
                detail.IdOrdenDeTrabajoDet === data.IdOrdenDeTrabajoDet
            );
            tempo2[index].IdPriority = e.value.IdPriority;
            tempo2[index].Priority = e.value.Priority;
            setDetalles(tempo2);
          }}
        />
      </div>
    );
  };
  
  const changeDescripcion = ({ data, column }) => {
    const index = detalles.findIndex(
      (detail) => detail.IdOrdenDeTrabajoDet === data.IdOrdenDeTrabajoDet
    );
    let newDetail = [...detalles];
    if (column.field === "Descripcion") {
      newDetail[index].Descripcion = data.Descripcion;
    }
    setDetalles(newDetail);
  };

  const agregarAsignacion = () => {
    setDetalles(prevDetalles => 
      prevDetalles.map(detalle => {
        const asignacionesPrevias = Array.isArray(detalle.Asignaciones) ? detalle.Asignaciones : [];

        // Filtrar las nuevas subTareas correspondientes a este detalle
        const nuevasSubTareas = asignaciones.filter(sub => 
          sub.IdOrdenDeTrabajoDet === detalle.IdOrdenDeTrabajoDet &&
          !asignacionesPrevias.some(prev => prev.IdAsignacion === sub.IdAsignacion) // Evitar duplicados
        );

        return {
          ...detalle,
          Asignaciones: [
            ...asignacionesPrevias, 
            ...nuevasSubTareas 
          ]
        };
      })
    );
};

  const columns = [
    {
      field: "IdOrdenDeTrabajoDet",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: true,
    },
    {
      field: "FechaCreado",
      header: "Fecha Creado",
      headerEn: "Date Create",
      frozen: true,
      className: "small",
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "Xsmall",
      Format: "Estado",
      frozen: true,
      body: (rowData) => ({
        ID: rowData.StatusName,
        Estado: rowData.StatusName,
      }),
    },
    {
      field: "CodigoActivo",
      header: "Código Activo",
      headerEn: "Active Code",
      className: "Xsmall",
      editable: habilitar,
      cellEditor: changeActivoF,
      hidden: !sinActivo
    },
    {
      field: "NombreActivo",
      header: "Nombre Activo",
      headerEn: "Active Name",
      className: "Xlarge",
      hidden: !sinActivo
    },
    {
      field: "Area",
      header: "Area",
      headerEn: "Area",
      className: "medium",
      editable: habilitar,
      cellEditor: changeArea,
    },
    {
      field: "TipoMantenimiento",
      header: "TipoMantenimiento",
      headerEn: "TipoMantenimiento",
      className: "medium",
      editable: habilitar,
      cellEditor: changeTipoMantenimiento,
    },
    {
      field: "TipoTrabajo",
      header: "TipoTrabajo",
      headerEn: "TipoTrabajo",
      className: "medium",
      editable: habilitar,
      cellEditor: changeTipoTrabajo,
    },
    {
      field: "Descripcion",
      header: "Descripción",
      headerEn: "Description",
      className: "XXXlarge",
      editable: habilitar,
      flex: 1,
      minWidth:200,
      onChange: (data) => changeDescripcion(data),
    },
    {
      field: "Priority",
      header: "Prioridad",
      headerEn: "Priority",
      className: "small",
      editable: habilitar,
      cellEditor: changePrioridad,
    },
    {
      field: "IdOrdenDeTrabajoDet",
      className: "small",
      header: "Asignar",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-plus",
          tooltip: "Agregar Asignaciones",
          disable: !habilitar,
          onClick: (rowData) => {
            // if(rowData?.IdOrdenDeTrabajoDet > 0){
              setModalAsignaciones(true)
              setSelected(rowData);
            // }else{
            //   toastShow(toast,"warn", "Advertencia", "Guarde el detalle antes de agregar Asignaciones.");
            // }
          },
          tooltipOptions: {
            position: "left",
          },
        },
        {
          icon: "pi pi-shopping-cart",
          tooltip: "Requisa de Compra",
          disable: !habilitar,
          onClick: (rowData) => {
            if(rowData?.IdOrdenDeTrabajoDet > 0){
              setAbrirRequisaCompras(true)
              setSelectedParaR(rowData)
            }else{
              toastShow(toast,"warn", "Advertencia", "Guarde el detalle antes de agregar Asignaciones.");
            }
          },
          tooltipOptions: {position: "left"},
        },
        {
          icon: "ri-building-4-line",
          tooltip: "Requisa de Material",
          disable: !habilitar,
          onClick: (rowData) => {
            if(rowData?.IdOrdenDeTrabajoDet > 0){
              setAbrirRequisaMaterial(true)
              setSelectedParaR(rowData)
            }else{
              toastShow(toast,"warn", "Advertencia", "Guarde el detalle antes de agregar Asignaciones.");
            }
          },
          tooltipOptions: {position: "left"},
        },
      ],
    },

    
  ];

  const table = {
    Columns: columns,
    Data: detalles,
    selected: selected,
    setSelected: setSelected,
    showModal: (e) => showModal(e),
  };

  const cerrarConfirmacionCompras = () => {
    if (habilitarReqCompras) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setAbrirRequisaCompras(false);
          setSelectedParaR(null)
        },
        rejectLabel: "No",
        reject: () => {},
        style: { backgroundColor: "white" },
      });
    } 
  };

  const cerrarConfirmacionMaterial = () => {
    if (habilitarReqCompras) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setAbrirRequisaMaterial(false);
          setSelectedParaR(null)
        },
        rejectLabel: "No",
        reject: () => {},
        style: { backgroundColor: "white" },
      });
    } 
  };

  const showModal = () => {
    setOrdenDialog(true);
  };

  useEffect(() => {
    if(values?.Type?.IdType === 0){
      setSinActivo(true)
    }else{
      setSinActivo(false)
    }
  }, [values?.Type?.IdType]);

  useEffect(() => {
    getInfo();
    setDetalles([]);
    if (idOrden) {
      obtenerOrdenT();
    } else {
      getInfoNew();
    }
  }, [idOrden]);

  return (
    <div>
      <Loader loading={loading} />
      <Toast ref={toast} />
      <EncabezadoOrdenesTrabajo
        values={values}
        handleInputChange={handleInputChange}
        handleChange={handleChange}
        setHabilitar={setHabilitar}
        toast={toast}
        resetForm={resetForm}
        detalles={detalles}
        setDetalles={setDetalles}
        getOrdenT={obtenerOrdenT}
        habilitar={habilitar}
        setValues={setValues}
        setIngresoToShow={setOrdenToShow}
        userSolicita={userSolicita}
        agregarNuevaFila={agregarNuevaFila}
        eliminarItemDetalle={eliminarItemDetalle}
        guardarIngresosBodega={guardarOrdenesTrabajo}
        listadoDet={listadoDet}
        areas={areas}
        types={types}
        sinActivo={sinActivo}
        setAbrirRequisaCompras={setAbrirRequisaCompras}
        setAbrirRequisaMaterial={setAbrirRequisaMaterial}
        setShowRequisas={setShowRequisas}
      />
      <Card
        contenido={
          <div style={{ height: "65vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />

      <Dialog
        visible={modalAsignaciones}
        onHide={() => {
          setModalAsignaciones(false)
        }}
        maximized={false}
        maximizable={true}
        closeOnEscape={false}
        style={{width: '61%', height: '70%'}}
        header={"Sub Tareas"}
      >
        <SubTareasCRUD
          detalleSeleccionado={selected}
          modalAsignaciones={modalAsignaciones}
          setModalAsignaciones={setModalAsignaciones}
          asignaciones = {asignaciones}
          setAsignaciones = {setAsignaciones}
          agregarAsignacion = {agregarAsignacion}
        />
      </Dialog>

      {/* Requisa Compra */}
      <Dialog
        visible={abrirRequisaCompras}
        onHide={() => {cerrarConfirmacionCompras()}}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <CrudRequisa
          showDialog={abrirRequisaCompras}
          habilitar={habilitarReqCompras}
          setHabilitar={setHabilitarReqCompras}
          item={selectedParaR ? selectedParaR : values}
        />
      </Dialog>
      
      {/* Requisa Material */}
      <Dialog
        visible={abrirRequisaMaterial}
        onHide={() => {cerrarConfirmacionMaterial()}}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <RequisaMaterialCrud
          setIngresoToShow={() => {}}
          showDialog={abrirRequisaMaterial}
          actualizarIngresosScreen={getInfo}
          habilitar={habilitarReqMaterial}
          setHabilitar={setHabilitarReqMaterial}
          item={selectedParaR ? selectedParaR : values}
        />
      </Dialog>

      {/* Listado de Requisas */}
      <Dialog
        visible={showRequisas}
        onHide={() => {
          setShowRequisas(false)
        }}
        closeOnEscape={false}
        style={{width: '61%', height: '70%'}}
      >
        <RequisasDeAsignaciones item={values}/>
      </Dialog>
    </div>
  );
};

export default OrdenesTrabajoCRUD;
